import axios from 'axios'
import _ from 'lodash'
import Vue from 'vue'
import TokenService from '../helpers/token'

const baseUrl = process.env.VUE_APP_API
const activeCodeUrl = process.env.VUE_APP_ACTIVE_CODE_API
const baseUrlTutor = process.env.VUE_APP_SORT_CLASS
const customerCareURL = process.env.VUE_APP_CUSTOMER_CARE_API
const shortLinkUrl = process.env.VUE_APP_API_SHORT_LINK
const baseAccountUrl = process.env.VUE_APP_API_ACCOUNT
const tokenAccount = process.env.VUE_APP_TOKEN_ACCOUNT
const linkExamURL = process.env.VUE_APP_EXAM_API
const uploadImageUrl = process.env.VUE_APP_UPLOAD_IMAGE_URL
const bituUrlReport = process.env.VUE_APP_API_BITU_REPORT
const duoUrl = process.env.VUE_APP_DOU_API
const pcmUrl = process.env.VUE_APP_PCM_API
const options = {
  baseURL: baseUrl,
  activeCodeURL: activeCodeUrl,
  baseUrlTutor: baseUrlTutor,
  customerCareURL: customerCareURL,
  shortLinkUrl: shortLinkUrl,
  baseAccountUrl: baseAccountUrl,
  tokenAccount: tokenAccount,
  linkExamURL: linkExamURL,
  uploadImageUrl: uploadImageUrl,
  bituUrlReport: bituUrlReport,
  duoUrl: duoUrl,
  pcmUrl,
}

if (TokenService.getToken() !== null) {
  options.headers = {
    Authorization: `Bearer ${TokenService.getToken()}`,
    Language: _.get(TokenService.getLang(), '', 'en'),
  }
}

const axiosInstance = axios.create(options)
const STATUS_UNAUTHORIZED = 401
const STATUS_TOKEN_EXPIRED = 402
const STATUS_CODE_FORBIDDEN = 403
const STATUS_SUCCESS = 200
const STATUS_INTERNAL_SERVER_ERROR = 500
const STATUS_INTERNAL_SERVER_MAINTENANCE = 452
const urlMaintenance = 'https://baotri.vuihoc.vn'

const sendRefreshToken = async (token) => {
  const response = await axios.post(`${baseUrl}/refresh-token`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const logout = () => {
  TokenService.removeToken()
  TokenService.removeRefreshToken()
  TokenService.removeUser()
  TokenService.removeRsa256Token()
  window.location.href = '/login'
}
let isErrorDisplayed = false;
const displayErrorMessage = (message) => {
  if (!isErrorDisplayed) {
    isErrorDisplayed = true;
    Vue.prototype.$swal({
      title: 'Lỗi',
      width: '400px',
      html: message,
      icon: 'error',
    }).then(() => {
      isErrorDisplayed = false;
    });
  }
};
axiosInstance.interceptors.response.use(
  async (response) => {
    const statusCode = _.get(response, 'data.code', STATUS_INTERNAL_SERVER_ERROR)
    if (statusCode === STATUS_SUCCESS) {
      return {
        success: true,
        currentTime: _.get(response, 'data.time_current', null) ,
        data: _.get(response, 'data.data', []),
        totalItem: _.get(response, 'data.totalItem', null),
      }
    }
    if (statusCode === STATUS_TOKEN_EXPIRED || statusCode === STATUS_UNAUTHORIZED) {
      logout()
    }
    if (statusCode === STATUS_CODE_FORBIDDEN && window.location.pathname !== '/error-403') {
      window.location.href = '/error-403'
    }
    if(statusCode === STATUS_INTERNAL_SERVER_MAINTENANCE) {
      window.location = urlMaintenance
    }

    return {
      error: true,
      message: _.get(response, 'data.message', ''),
      status: _.get(response, 'data.code', STATUS_INTERNAL_SERVER_ERROR),
      errors: _.get(response, 'data.errors', []),
    }
  },

  async (error) => {
    const data = {
      apiUrl: error.config.url,
      httpStatus: error.config.status ? error.config.status : 0,
      data:  {
        data: error.config.data ?  error.config.data : '',
        params: error.config.params ?  error.config.params : '',
        methods: error.config.method ? error.config.method : '',
        message: error.message
      },
    };
    let message = '';
    if (!error.response && error.message.includes('Network Error')) {
      message = 'Vui lòng thử lại sau.';
    } else if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
      message = 'Yêu cầu kết nối đã hết thời gian chờ.<br/> Máy chủ có thể không phản hồi.';
    }
    if (message !== '') {
      try{
        await axios.post(`${baseUrl}/log/tracking-api`, data, {
          headers: {
            Authorization: `Bearer ${TokenService.getToken()}`,
          },
        });
      }catch (e) {
        console.log(e);
      }
      displayErrorMessage(message);
      return
    }

    if(error.response && error.response.status === STATUS_INTERNAL_SERVER_MAINTENANCE) {
      window.location = urlMaintenance
    }
    if (error.response) {
      return {
        error: true,
        status: STATUS_INTERNAL_SERVER_ERROR,
        message: _.get(error, 'message', ''),
        errors: _.get(error, 'response.data', {}),
      }
    } if (error.request) {
      return {
        error: true,
        status: STATUS_INTERNAL_SERVER_ERROR,
        message: _.get(error, 'message', ''),
        errors: _.get(error, 'request', {}),
      }
    }
    return {
      error: true,
      status: STATUS_INTERNAL_SERVER_ERROR,
      message: _.get(error, 'message', ''),
    }
  }
  ,
)

export default axiosInstance
